/**
 * Statistics helper functions for extracting and formatting numeric data
 * from various content types (strings, RichText, etc.)
 */

/**
 * Extract numeric value from string or RichText content
 */
export const extractNumber = (value: any): number => {
  // todo: get the number value from json.content[0].content[0].value
  if (typeof value === 'string') {
    const match = value.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }
  if (value?.json?.content?.[0]?.content?.[0]?.value) {
    const str = value.json.content[0].content[0].value;
    const match = str.match(/[^\d\s]+/);
    return match ? match[0] : 0;
  }
  if (value?.description?.json?.content?.[0]?.content?.[0]?.value) {
    const str = value.description.json.content[0].content[0].value;
    const match = str.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }
  return 0;
};

/**
 * Extract suffix (like +, %, etc.) from string or RichText content
 */
export const extractSuffix = (value: any): string => {
  // note: the suffix is only get from RichText content json.content[0].content[0].value, example value "57K+", it should not have any other value other than the "K+"
  // todo: handle the two cases of data types, the suffix value is from string, and is from json.content[0].content[0].value
  if (typeof value === 'string') {
    const match = value.match(/[^\d\s]+/);
    return match ? match[0] : '';
  }

  if (value?.json?.content?.[0]?.content?.[0]?.value) {
    const str = value.json.content[0].content[0].value;
    const match = str.match(/[^\d\s]+/);
    return match ? match[0] : '';
  }
  if (value?.description?.json?.content?.[0]?.content?.[0]?.value) {
    const str = value.description.json.content[0].content[0].value;
    const match = str.match(/[^\d\s]+/);
    return match ? match[0] : '';
  }
  return '';
};

/**
 * Format display value by replacing number with animated count
 */
export const formatDisplayValue = (
  originalValue: any,
  animatedNumber: number,
): any => {
  if (typeof originalValue === 'string') {
    return originalValue.replace(/\d+/, animatedNumber.toLocaleString());
  }

  if (originalValue?.json) {
    // For RichText, return the animated number with suffix
    const suffix = extractSuffix(originalValue);
    return `${animatedNumber.toLocaleString()}${suffix}`;
  }

  return animatedNumber.toLocaleString();
};
